(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prosafe-catalog"] && !Shopify.designMode) return;
  try {
    
function initProsafeCatalog(scope=document){scope.querySelectorAll('[data-ps-catalog]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const search=root.querySelector('[data-ps-search]'),select=root.querySelector('[data-ps-category]'),cards=[...root.querySelectorAll('[data-ps-card]')];const normalize=s=>s.normalize('NFD').replace(/[̀-ͯ]/g,'').toLowerCase();function filter(){let shown=0;cards.forEach(card=>{const visible=(!select.value||card.dataset.category===select.value)&&normalize(card.textContent).includes(normalize(search.value));card.hidden=!visible;if(visible)shown++});root.querySelector('[data-ps-empty]').hidden=shown>0}search.addEventListener('input',filter);select.addEventListener('change',filter);document.querySelectorAll('.ps-quick a').forEach(link=>link.addEventListener('click',()=>{search.value='';select.value='';filter()}))})}initProsafeCatalog();document.addEventListener('shopify:section:load',event=>initProsafeCatalog(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prosafe-contact"] && !Shopify.designMode) return;
  try {
    
const prosafeInterest=document.getElementById('ps-interest');if(prosafeInterest){const value=new URLSearchParams(window.location.search).get('formation');if(value)prosafeInterest.value=value.slice(0,200);}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prosafe-hero"] && !Shopify.designMode) return;
  try {
    
function initProsafeSlider(scope=document){scope.querySelectorAll('[data-ps-slider]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const slides=[...root.querySelectorAll('[data-ps-slide]')],dots=[...root.querySelectorAll('[data-ps-dot]')];if(slides.length<2)return;let current=0,timer;const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;function show(next){current=(next+slides.length)%slides.length;slides.forEach((slide,i)=>{const active=i===current;slide.classList.toggle('is-active',active);slide.setAttribute('aria-hidden',active?'false':'true')});dots.forEach((dot,i)=>{const active=i===current;dot.classList.toggle('is-active',active);dot.setAttribute('aria-current',active?'true':'false')})}function stop(){clearInterval(timer)}function start(){stop();if(!reduced)timer=setInterval(()=>show(current+1),Number(root.dataset.autoplay)||6000)}root.querySelector('[data-ps-prev]')?.addEventListener('click',()=>{show(current-1);start()});root.querySelector('[data-ps-next]')?.addEventListener('click',()=>{show(current+1);start()});dots.forEach(dot=>dot.addEventListener('click',()=>{show(Number(dot.dataset.psDot));start()}));root.addEventListener('mouseenter',stop);root.addEventListener('mouseleave',start);root.addEventListener('focusin',stop);root.addEventListener('focusout',start);start()})}initProsafeSlider();document.addEventListener('shopify:section:load',event=>initProsafeSlider(event.target));

  } catch(e) { console.error(e); }
})();
})();
